import React from "react";

import { Typography } from "clearsense-ui/components";
import ExploreContainer from "components/Common/ExploreContainer";

const AnalyticsSolutions = () => (
  <ExploreContainer>
    <div className="flex justify-between">
      <Typography style="h3" type="semibold">
        Analytics Solutions
      </Typography>
    </div>
  </ExploreContainer>
);

export default AnalyticsSolutions;
